// LoadingComponent.js
import img from '../../assets/animtion .gif';
import React from 'react';
import './loading.css'; // Import CSS file with loading animation

const Loading = () => {
  return (
    <div className="loading-container ">
        <div className='animate__animated animate__backInDown '>
      <div className="loading-animation ">
        <img src={img} alt="Loading..."/>
        </div>
      </div>

    </div>
  );
};

export default Loading;
